// extracted by mini-css-extract-plugin
export default {"rowsWrapper":"TextLoader_rowsWrapper__VQRe5","loading":"TextLoader_loading__+qnsi","salmon":"TextLoader_salmon__kKFeh","gray":"TextLoader_gray__pEHS7"};